import Vue from 'vue'

import SlAMap from './sl-amap/'
import VueSl from './vue-sl'
import VueTy from './vue-ty'

const Components = [
  VueSl, VueTy, SlAMap
]

Components.map((com) => {
  if (com.install) {
    Vue.use(com)
  } else {
    Vue.component(com.name, com)
  }
})

export default Vue
